import React from 'react';
import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { Battery, Bike, Package, Settings, Handshake, ChartNoAxesCombined, Wallet } from "lucide-react";

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: "bms",
      label: "BMS",
      icon: <Battery color="white" />,
      children: [
        { key: "/", label: "Dashboard" },
        { key: "/dispatch", label: "Dispatch" },
        { key: "/swap", label: "Swap" },
        { key: "/batteries", label: "Batteries" },
        { key: "/riders", label: "Riders" },
        { key: "/franchises", label: "Franchises" },
        { key: "/fleets", label:"Fleets"},
        { key: "/operators", label: "Operators" },
        { key: "/track", label: "Track" },
      ],
    },
    {
      key: "delivery",
      label: "Delivery",
      icon: <Package color="white" />,
      children: [
        { key: "/customers", label: "Customers" },
        { key: "/deliveries", label: "Deliveries" },
        // { key: "/products", label: "Products" }
      ],
    },
    {
      key: "fleet",
      label: "Fleet",
      icon: <Bike color="white" />,
      children: [
        { key: "/fleet/clients", label: "Clients" },
        { key: "/fleet/bikes", label: "Bikes" },
        { key: "/fleet/maintenance", label: "Maintenance" },
        { key: "/fleet/inventory", label: "Inventory" },
        { key: "/fleet/tracking", label: "Tracking" },     
      ],
    },
    {
      key: "sales",
      label: "Sales",
      icon: <Handshake color="white" />,
      children: [
        { key: "/sales/leads", label: "Leads" },
        { key: "/sales/customers", label: "Customers" },
      ],
    },{
      key: "finance",
      label: "Finance",
      icon: <Wallet color="white" />,
      children: [
        { key: "/finance/payments", label: "Bolt Send" },
        { key: "/finance/invoices", label: "Invoices" },
      ],
    },
    {
      key: "dashboards",
      label: "Dashboards",
      icon: <ChartNoAxesCombined color="white" />,
      children: [
        { key: "/bolt", label: "BOLT" },
        { key: "/kutuma", label: "KUTUMA" },
        // { key: "/products", label: "Products" }
      ],
    },
    { key: "/profile", label: "Settings", icon: <Settings color="white" /> },
  ];

  const onMenuItemClicked = ({ key }) => {
    navigate(key);
  };

  return (
    <Menu
      onClick={onMenuItemClicked}
      selectedKeys={[location.pathname]}
      mode="inline"
      items={menuItems}
      theme="dark"
    />
  );
};

export default SideBar;